import React, { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { setLocale } from 'yup';

import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import Dashboard from './layouts/Dashboard';
import store from './redux/store/index';
import PageRouteList from './routes/PageRouteList';

setLocale({
   mixed: {
      required: 'Required!',
   },
   number: {
      // eslint-disable-next-line no-template-curly-in-string
      min: 'Must be at least ${min}!',
      // eslint-disable-next-line no-template-curly-in-string
      max: 'Must not exceed ${max}!',
      // eslint-disable-next-line no-template-curly-in-string
      moreThan: 'Must be more than ${moreThan}!',
      // eslint-disable-next-line no-template-curly-in-string
      lessThan: 'Must be less than ${lessThan}!',
   },
});

const materialTheme = createTheme({
   typography: {
      fontFamily: [
         'apercu-extralight',
      ],
   },
   palette: {
      primary: {
         main: '#00c853',
         light: '#5efc82',
         dark: '#009624',
         contrastText: '#000000',
      },
      secondary: {
         main: '#2d9cdb',
         light: '#6fcdff',
         dark: '#006ea9',
         contrastText: '#ffffff',
      },
      error: {
         main: '#EB5757',
         light: '#F6999A',
         dark: '#EB5757',
      },
   },
});

const App = () => {
   return (
     <StrictMode>
         <BrowserRouter basename='/t'>
            <ThemeProvider theme={materialTheme}>
               <Provider store={store}>
                  <Dashboard>
                     <PageRouteList/>
                  </Dashboard>
                  <ReduxToastr
                     timeOut={5000}
                     newestOnTop
                     position='bottom-center'
                     transitionIn='fadeIn'
                     transitionOut='fadeOut'
                     progressBar
                     closeOnToastrClick
                  />
               </Provider>
            </ThemeProvider>
         </BrowserRouter>
     </StrictMode>
   );
};
export default App;
